import React, { useEffect, useState } from "react";
import PageBanner from "../../components/PageBanner";
import BulletParagraph from "../../components/content/BulletParagraph";
import RichText from "../../components/content/RichText";
import AppointmentService from "../../services/appointment";
import { useParams } from "react-router-dom";
import ContentImage from "../../components/content/ContentImage";

export default function AppointmentDetail(props) {
  let [appointmentData, setAppointmentData] = useState([]);
  let { id, lang } = useParams();

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getAppointmentData = async () => {
    try {
      let res = await AppointmentService.getAppointmentByName(`/${id}`);

      if (res) {
        setAppointmentData(res);
      }
      //   else {
      // window.open(
      //   `/appointment`,
      //   "_self"
      // )
      //   }
    } catch {
      console.error();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getAppointmentData();
    // eslint-disable-next-line
  }, []);

  function appointmentTitle(text) {
    return (
      <h1 className="text-heading font-bold text-slateGray text-left my-[50px]">
        {text}
      </h1>
    );
  }

  function appointmentImage(data) {
    return (
      <div
        className={
          `flex items-start gap-[46px] ` + (!data.imageIsLeft && "flex-row-reverse")
        }
      >
        <ContentImage image={data?.image} lang={lang} />
        <RichText
          className="w-full"
          html={
            lang === "th" ? data.detail[0].detail_TH : data.detail[0].detail_EN
          }
        />
      </div>
    );
  }

  const bannerText = [
    { name: "appointment", href: "/appointment" },
    {
      name: appointmentData?.link?.label_EN,
    },
  ];

  return (
    <div className="service-info pt-[135px] lg:pt-[0px]">
      {appointmentData.link ? (
        <PageBanner
          banner={appointmentData.image}
          text_th={`${appointmentData.link.label_TH}`}
          text_en={`${appointmentData.link.label_EN}`}
          bannerText={bannerText}
          lang={lang}
        />
      ) : (
        <PageBanner text_th={``} text_en={``} />
      )}

      <div className="section">
        <div className="page-container">
          {/* บริการ แยก */}
          <div className="mt-[92px] mb-[300px]">
            {appointmentData?.link && appointmentData?.link?.label_TH && (
              <h1 className="text-heading font-bold text-slateGray text-left">
                {lang === "th"
                  ? appointmentData.link.label_TH
                  : appointmentData.link.label_EN}
              </h1>
            )}
            <div>
              {appointmentData?.body &&
                appointmentData?.body?.map((appointment, i) => (
                  <div key={i}>
                    {appointment.__component === "global.title" &&
                      appointmentTitle(
                        lang === "th"
                          ? appointment.title_th
                          : appointment.title_en
                      )}

                    {appointment.__component === "global.image-content" &&
                      appointmentImage(appointment)}

                    {(appointment.__component === "global.detail" ||
                      appointment.__component === "global.rich-detail") && (
                      <RichText
                        html={
                          lang === "th"
                            ? appointment.detail_TH
                            : appointment.detail_EN
                        }
                      />
                    )}

                    {appointment.__component === "about.bullet" && (
                      <div className="mt-[32px]">
                        {BulletParagraph(
                          lang === "th"
                            ? appointment.title_TH
                            : appointment.title_EN,
                          lang === "th"
                            ? appointment.detail_TH
                            : appointment.detail_EN
                        )}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
